import { loadHermesData } from 'ha/modules/Hermes';

export default (store, getComponentsWithNotFound) => (nextState, callback) => {
  store
    .dispatch(loadHermesData(nextState.location.pathname))
    .then(() => getComponentsWithNotFound('Cities')(nextState, callback));
};
